import { useEffect, useRef, useState } from 'react'
import { Container } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import BookConsultationCTA from '../common/BookConsultationCTA/BookConsultationCTA'
import ChartAndNav from './ChartAndNav/ChartAndNav'
import Footer from '../Footer/Footer'
import ResultsHeader from './ResultsHeader/ResultsHeader'
import ResultsTable from './ResultsTable/ResultsTable'
import ResultsText from './ResultsText/ResultsText'
import { getChartDataMod1 } from './ResultsUtils/getChartDataMod1'
import { getBenchForAll, getBenchForCat, getSurveyAndReportData } from './ResultsUtils/apiCallsForResults'
import { CONSTRUCT_ARRAY, CONSTRUCTS } from '../../utils/constructs'
import { CATEGORY_BENCHMARK_UNAVAILABLE } from '../../utils/constants'

// render the Module 1 (Step 2) survey results; route '/results'
const ResultsModule1 = () => {
  const jt = useSelector(state => state.jsonText.jsonText)
  const user = useSelector(state => state.user.user)
  // console.log('user:', user)
  const [benchModAll, setBenchModAll] = useState(null) // benchmark of all NPOs
  const [benchModCat, setBenchModCat] = useState(null) // benchmark of user's NPO category
  const [modNpoAnswers, setModNpoAnswers] = useState(null)  // NPO survey answer object for current module
  const [modAllResults, setModAllResults] = useState(null)  // results compared with all NPOs
  const [modCatResults, setModCatResults] = useState(null)  // results compared with user's NPO category
  // const [modBenchCatResults, setModBenchCatResults] = useState(null)  // NPO category compared with all NPOs
  const [modFeedbackTexts, setModFeedbackTexts] = useState({})
  const [chartImages, setChartImages] = useState({})
  const [pdfReportUrl, setPdfReportUrl] = useState('')
  const noCatBenchInfoHasBeenShown = useRef(null)

  useEffect(() => {
    // get latest benchmark
    if (user.strapiJwt && jt.toast) {
      // console.log('user:', user)
      if (!benchModAll) { // only run this once
        getBenchForAll('1', setBenchModAll).then()
      }
      if (!benchModCat) { // only run this once
        getBenchForCat('1', user.orgCategory, jt.toast, noCatBenchInfoHasBeenShown, setBenchModCat).then()
      }
      // get the latest answers for this user if they have fully completed this module
      if (benchModAll && benchModCat) {
        // console.log("BenchModCat:", benchModCat)
        getSurveyAndReportData(
          '1',
          user.orgID,
          jt.results,
          benchModAll,
          benchModCat,
          setModNpoAnswers,
          setModAllResults,
          setModCatResults,
          setModFeedbackTexts,
          CONSTRUCT_ARRAY.M1,
          setPdfReportUrl,
        ).then()
      }
    }
    // eslint-disable-next-line
  }, [jt, user, benchModAll, benchModCat])

  const useAll = !benchModCat || benchModCat === CATEGORY_BENCHMARK_UNAVAILABLE
  const [benchMod, modResults, benchType] = useAll
    ? [benchModAll, modAllResults, 'all']
    : [benchModCat, modCatResults, 'cat']

  const firstArgs = [
    jt.label,
    modNpoAnswers,
    benchMod,
    modResults,
    benchType,
    null, // only used for yearly comparisons
  ]
  // console.log("firstArgs:", firstArgs)

  const chartData = modResults && benchMod ?
    {
      first: getChartDataMod1(...firstArgs, 'summary'),
      second: getChartDataMod1(...firstArgs, CONSTRUCTS.FUTURE_ORIENTATION.name),
      third: getChartDataMod1(...firstArgs, CONSTRUCTS.ACTIVATION.name),
    }
    : null

  const chartLabels = {
    first: jt.label?.mod1Overview || 'Module 1 Overview',
    second: jt.label?.[CONSTRUCTS.FUTURE_ORIENTATION.name] || 'Future Orientation',
    third: jt.label?.[CONSTRUCTS.ACTIVATION.name] || 'Future Orientation',
  }

  return (
    <div>
      <ResultsHeader
        module={'module1'}
        chartsLoaded={!!chartImages.third?.imgData}
        chartImages={chartImages}
        benchModAll={benchModAll}
        benchModCat={benchModCat}
        modAllResults={modAllResults}
        modCatResults={modCatResults}
        constructs={CONSTRUCT_ARRAY.M1}
        feedbackTexts={modFeedbackTexts}
        pdfReportUrl={pdfReportUrl}
      />

      <Container>
        <ChartAndNav
          chartData={chartData}
          chartLabels={chartLabels}
          type={'radar'}
          setChartImages={setChartImages}
        />
        {chartData &&
          <ResultsTable
            module={'module1'}
            benchModAll={benchModAll}
            benchModCat={benchModCat}
            modAllResults={modAllResults}
            modCatResults={modCatResults}
            constructs={CONSTRUCT_ARRAY.M1}
          />
        }
        <ResultsText
          module={'module1'}
          constructs={CONSTRUCT_ARRAY.M1}
          modAllResults={modAllResults}
          modCatResults={modCatResults}
          feedbackTexts={modFeedbackTexts}
        />

        <BookConsultationCTA />
      </Container>
      <Footer />
    </div>
  )
}

export default ResultsModule1
